import { useEffect, useState } from "react";
import CommonModal from "./CommonModel/CommonModal";
import Typography from "./Typography";
import Button from "./Button/Button";
import {
  GLOBAL_API_ERROR_MODAL_EVENT,
  setGlobalApiErrorModalOpen,
} from "../utils/globalApiErrorModal";

const DEFAULT_TITLE = "Unable to Process Request — Retry";

export default function GlobalApiErrorModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState(DEFAULT_TITLE);
  const [message, setMessage] = useState("Something went wrong.");

  useEffect(() => {
    const onOpen = (ev) => {
      const detail = ev?.detail ?? {};
      const nextMessage =
        typeof detail.message === "string" && detail.message.trim()
          ? detail.message.trim()
          : "Something went wrong.";
      const nextTitle =
        typeof detail.title === "string" && detail.title.trim()
          ? detail.title.trim()
          : DEFAULT_TITLE;
      setTitle(nextTitle);
      setMessage(nextMessage);
      setIsOpen(true);
      setGlobalApiErrorModalOpen(true);
    };
    window.addEventListener(GLOBAL_API_ERROR_MODAL_EVENT, onOpen);
    return () => {
      window.removeEventListener(GLOBAL_API_ERROR_MODAL_EVENT, onOpen);
      setGlobalApiErrorModalOpen(false);
    };
  }, []);

  const handleClose = () => {
    setGlobalApiErrorModalOpen(false);
    setIsOpen(false);
  };

  return (
    <CommonModal isOpen={isOpen} onClose={handleClose} title={title} width="max-w-lg">
      <div className="space-y-4">
        <Typography className="text-text-primary">{message}</Typography>
        <div className="flex justify-end">
          <Button type="button" variant="primary" size="sm" onClick={handleClose}>
            OK
          </Button>
        </div>
      </div>
    </CommonModal>
  );
}
